import { PlusOutlined, ReloadOutlined } from "@ant-design/icons"
import { Button, Tooltip } from "antd"
import type React from "react"
import { memo } from "react"

interface VideoTableActionsProps {
  onAdd: () => void
  onRefresh: () => void
  loading?: boolean
}

export const VideoTableActions: React.FC<VideoTableActionsProps> = memo(({ onAdd, onRefresh, loading = false }) => {
  return (
    <div className="flex grow items-center justify-end gap-2">
      <Tooltip title="Thêm video YouTube mới">
        <Button type="primary" size="small" icon={<PlusOutlined />} onClick={onAdd}>
          Thêm video
        </Button>
      </Tooltip>

      <Tooltip title="Tải lại danh sách">
        <Button type="default" size="small" icon={<ReloadOutlined />} onClick={onRefresh} loading={loading} />
      </Tooltip>
    </div>
  )
})

VideoTableActions.displayName = "VideoTableActions"
